import RuleModal from '@/components/business/games/rule';
import React, {useState, forwardRef} from 'react';
import {useTranslation} from 'react-i18next';

export interface WeekCardRulesRef {
  open: () => void;
}

const WeekCardRules = forwardRef<WeekCardRulesRef>((_, ref) => {
  const [visible, setVisible] = useState(false);
  const {t} = useTranslation();

  React.useImperativeHandle(ref, () => ({
    open: () => setVisible(true),
  }));

  return (
    <RuleModal
      visible={visible}
      title={t('vip.rules.title')}
      onClose={() => setVisible(false)}>
      <div className="flex flex-col gap-3">
        <p className="text-t1 text-sm font-semibold">
          {t('vip.rules.subtitle1')}
        </p>
        <ul className="list-disc text-t2 text-sm font-normal ml-3">
          <li>{t('vip.rules.sub1paragraph1')}</li>
          <li>{t('vip.rules.sub1paragraph2')}</li>
        </ul>
        <p className="text-t1 text-sm font-semibold">
          {t('vip.rules.subtitle2')}
        </p>
        <ul className="list-disc text-t2 text-sm font-normal ml-3">
          <li>{t('vip.rules.sub2paragraph1')}</li>
          <li>{t('vip.rules.sub2paragraph2')}</li>
        </ul>
        <p className="text-t1 text-sm font-semibold">
          {t('vip.rules.subtitle3')}
        </p>
        <ul className="list-disc text-t2 text-sm font-normal ml-3">
          <li>{t('vip.rules.buyTip')}</li>
          <li>{t('vip.rules.sub3paragraph1')}</li>
          <li>{t('vip.rules.sub3paragraph2')}</li>
        </ul>
        <p className="text-t1 text-sm font-semibold">
          {t('vip.rules.subtitle4')}
        </p>
        <ul className="list-disc text-t2 text-sm font-normal ml-3">
          <li>{t('vip.rules.sub4paragraph1')}</li>
          <li>{t('vip.rules.sub4paragraph2')}</li>
        </ul>
        <p className="text-t1 text-sm font-semibold">
          {t('vip.rules.subtitle5')}
        </p>
        <ul className="list-disc text-t2 text-sm font-normal ml-3">
          <li>{t('vip.rules.sub5paragraph1')}</li>
          <li>{t('vip.rules.sub5paragraph2')}</li>
          <li>{t('vip.rules.sub5paragraph3')}</li>
        </ul>
        <div className="mt-3 flex flex-col text-t2 text-sm font-normal">
          <p>{t('vip.rules.sub5remark1')}</p>
          <p>{t('vip.rules.sub5remark2')}</p>
        </div>
      </div>
    </RuleModal>
  );
});

export default WeekCardRules;
